import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { selectedStockManagementTable } from 'src/infrastructure/local_state';

export const useSelectedStockManagementTable = () => {
    return useReactiveVar(selectedStockManagementTable);
};
